import { render, staticRenderFns } from "./DamCompareWater.vue?vue&type=template&id=72040666&scoped=true"
import script from "./DamCompareWater.vue?vue&type=script&lang=ts"
export * from "./DamCompareWater.vue?vue&type=script&lang=ts"
import style0 from "./DamCompareWater.vue?vue&type=style&index=0&id=72040666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72040666",
  null
  
)

export default component.exports